import {loadScript, observe} from "../utils/scripts";

export type initStripeArgs = {
  key: string;
  secret: string;
  returnUrl: string;
};

export const initStripe = ({key, secret, returnUrl}: initStripeArgs) => {
  loadScript("https://js.stripe.com/v3/", () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const stripe = Stripe(key);
    const options = {
      clientSecret: secret,
      fonts: [{cssSrc: "https://fonts.googleapis.com/css2?family=Inter"}],
      appearance: {
        theme: "stripe",
        variables: {
          fontSizeBase: "16px",
          colorDanger: "rgb(239, 68, 68)",
        },
      },
    };

    const elements = stripe.elements(options);
    const paymentElement = elements.create("payment");
    paymentElement.mount("#payment-element");

    const form = document.getElementById("payment-form");
    if (form) {
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        const submitButton = document.getElementById("payment-submit") as HTMLButtonElement;
        if (submitButton) {
          submitButton.disabled = true;
        }

        const {error} = await stripe.confirmSetup({
          elements,
          confirmParams: {
            return_url: returnUrl,
          },
        });

        if (error) {
          const errorMessage = document.getElementById("error-message");
          if (errorMessage) {
            errorMessage.textContent = error.message;
          }
          if (submitButton) {
            submitButton.disabled = false;
          }
        }
      });
    }
  });
};

observe("#payment-form", (el, added) => {
  if (added) {
    const key = el.getAttribute("data-key");
    const secret = el.getAttribute("data-secret");
    const returnUrl = el.getAttribute("data-return-url");
    if (key && secret && returnUrl) {
      initStripe({key, secret, returnUrl});
    }
  }
});
